<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">      
        <b-col md="7">

          <b-card-group>
            <b-card no-body class="modal-primary p-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <h2 class="text-dark">Register</h2>
            </div>
              <b-card-body> 
                <form>
                    
                   <b-row>
                      <b-col class="col-12">
                          <h5>User Details</h5>
                          <hr>
                      </b-col>
                  </b-row>


                    <b-row>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="id">Firstname<span class="required">*</span></label> 
                          <b-form-input type="text" id="firstname" v-model="user.firstname" @keyup.native="changeEventHandler"></b-form-input>
                          <small class="text-danger font-weight-bold">{{ validation.firstError('user.firstname') }}</small>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="id">Lastname<span class="required">*</span></label> 
                          <b-form-input type="text" id="lastname" v-model="user.lastname" @keyup.native="changeEventHandler"></b-form-input>
                          <small class="text-danger font-weight-bold">{{ validation.firstError('user.lastname') }}</small>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Position<span class="required">*</span></label> 
                            <b-form-input type="text" id="position" v-model="user.position" @keyup.native="changeEventHandler"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.position') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Organization/Agency<span class="required">*</span></label>
                            <b-form-select v-model="agencyId" 
                                   type="text" placeholder="Agency" 
                                   text-field="name" 
                                   value-field="id" 
                                   :options="agencyList"> 
                                   <template slot="first">
                                      <option :value="null" disabled>-- Please select an option --</option>
                                  </template>
                            </b-form-select>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('agencyId') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">E-mail<span class="required">*</span></label>
                            <b-input-group>
                              <b-form-input type="text" id="email_address" v-model="user.email_address" @keyup.native="changeEventHandler"></b-form-input>
                              <b-input-group-append>
                                <b-btn @click="sendCode" title="Click to send verification code" :disabled="!(user.firstname) || !(user.email_address)">Send</b-btn>
                              </b-input-group-append>
                            </b-input-group>
                            <!-- <small class="text-muted"><i class="fa fa-lightbulb-o text-warning fa-1x"></i> Click "Send" to request a verification code.</small> -->
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.email_address') }}</small>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('isEmailValid') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6"> 
                          <b-form-group>
                            <label for="id">Verification Code<span class="required">*</span></label>
                            <b-input-group>
                              <b-form-input type="text" v-model="verification_code" @keyup.native="changeEventHandler"></b-form-input>
                              <b-input-group-append>
                                <b-btn @click="verifyCode" title="Submit verification code" :disabled="!(user.email_address) || !(verification_code)"> Send </b-btn>
                              </b-input-group-append>
                            </b-input-group>                            
                            <small class="text-danger font-weight-bold">{{ validation.firstError('verification_code') }}</small>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('isVCodeValid') }}</small>
                          </b-form-group>                          
                        </b-col>
                      </b-row>

                      <b-row>
                         <b-col sm="6">
                            <b-form-group>
                              <label for="id">Phone</label> 
                              <b-form-input type="text" id="phone" v-model="user.phone" @keyup.native="changeEventHandler"></b-form-input>
                              <small class="text-danger font-weight-bold">{{ validation.firstError('user.phone') }}</small>
                            </b-form-group>
                         </b-col>
                      </b-row>   

                      <br>
                      <b-row>
                        <b-col class="col-12">
                            <h5>Account Details</h5>
                            <hr>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Username<span class="required">*</span></label> 
                            <b-form-input type="text" id="username" v-model="user.username" autocomplete="username" @keyup.native="changeEventHandler" disabled></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.username') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>  
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Password<span class="required">*</span></label> 
                            <b-form-input type="password" id="credential" v-model="user.credential" autocomplete="new-password" @keyup.native="changeEventHandler"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.credential') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Confirm password<span class="required">*</span></label> 
                            <b-form-input type="password" id="confirm_credential" autocomplete="new-password" v-model="confirm_credential" @keyup.native="changeEventHandler"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('confirm_credential') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>
                </form>
                 <vue-recaptcha
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    @expired="onCaptchaExpired"
                    size="invisible"
                    sitekey="6LewvX4UAAAAAM0KwegvnUJdt2RyJR65HBhPXPjz">
                </vue-recaptcha>  
              </b-card-body>

              <!-- FOOTER -->  
            <div slot="footer" class="float-right">               
                <!-- <b-button variant="primary" @click="submitEventHandler" :disabled="!this.modified"><i class="fa fa-save"></i> Submit</b-button> -->
                <b-button variant="primary" @click="submitEventHandler" :disabled="!this.modified"><i class="fa fa-save"></i> Submit</b-button>
                <b-button variant="secondary" @click="cancelEventHandler"> <i class="fa fa-times"></i> Cancel</b-button>
            </div>
            <!--// FOOTER -->  
            
            </b-card>
           
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import userRegisterMixin from '@/mixins/validators/UserRegister-validators'
import UserService from '@/api/UserService'
import NotificationService from '@/api/NotificationService'
import * as utils from '@/mixins/utils'

import toast from '@/mixins/toast'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'


export default {
  name: 'Login',
  components: { 
    VueRecaptcha 
  },

  mixins: [
    userRegisterMixin
  ],  
  data () {
      return {
        agencyId: 0,
        confirm_credential: null,
        recaptchaToken: null,
        verification_code: null,
        isEmailValid: false,
        isVCodeValid: false,
        user: {
          firstname: null,
          lastname: null,
          position: null,
          email_address: null,
          phone: null,
          username: null,
          credential: null,
          created_date: null,
          updated_date: null          
        }
      }
  },     
   computed: { 
      ...mapGetters({
          modified: types.GET_MODIFIED,
          agencyList: types.GET_AGENCIES
      })
  },

  methods: {

    sendCode: function() {
      let _self = this
      let payload = {
         firstname: this.user.firstname,
         lastname: this.user.lastname,
         email_address: this.user.email_address,
         code: null
      }

      // console.log("***********")
      // console.log(payload)
      // console.log("***********")

      UserService.sendVCode(payload).then( (resp) => {
          if (resp) {
              _self.isEmailValid = true
              toast.success("We sent a verification code to your email address "+ this.user.email_address)
          }
      })

    },

    verifyCode: function() {

      let _self = this

      let payload = {
         firstname: this.user.firstname,
         lastname: this.user.lastname,
         email_address: this.user.email_address,
         code: this.verification_code
      }

      // console.log("***********")
      // console.log(payload)
      // console.log("***********")

      UserService.verifyVCode(payload).then( (resp) => {
          if (resp) {
              if (resp.success) {
                  _self.isVCodeValid = true
                  toast.success("Your verification code is valid.")
              }
              else {                  
                  _self.isVCodeValid = false
                  toast.error("Invalid verification code.  Please enter a valid verification code.", "Error")
              }
          }
      })

    },

    onSubmit: function () {
      // this.status = "submitting";
      // this.$refs.recaptcha.execute();
    },

    onCaptchaVerified(recaptchaToken) {

      const self = this
      self.recaptchaToken = recaptchaToken
      self.$refs.recaptcha.reset();

      self.submitEventHandler()

    },

    onCaptchaExpired() {
        this.$refs.recaptcha.reset()
    },

    changeEventHandler(e) {

      this.$store.commit(types.MUTATE_MODIFIED, true)

      if (e.target.id === 'email_address') {
          this.user.username = e.target.value
      }

    },

    // onSubmit () {        
        //this.$store.dispatch(types.ACTION_AUTH_USER, {username: this.username, password: this.password})
    // },

    submitEventHandler() {
        const $this = this

         this.$validate()
          .then(function(success) {

            // check if email is valid
            // if (!$this.isEmailValid) {
            //      toast.error( "You need to verify your email address.  Click \"Send\" to request for verification code", "Error")
            //      return false
            // }


             if (success) {

                 const payload = {
                      id: 0,
                      agency_id: $this.agencyId,
                      username: $this.user.username,
                      firstname: $this.user.firstname,
                      lastname: $this.user.lastname,
                      credential: $this.user.credential,
                      created_date: $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                      updated_date: $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                      email_address: $this.user.email_address,
                      position: $this.user.position,
                      phone: $this.user.phone,
                      active: $this.user.active,
                      recaptchaToken: $this.recaptchaToken
                  }
                
                  if (payload.id == 0) {
                      // new record
                      //$this.$store.dispatch(types.ACTION_ADD_USER, payload)
                      //$this.$store.commit(types.MUTATE_MODIFIED, false)
                       UserService.addUser(payload)
                           .then ( (response) => {
                                  if (response) {

                                      $this.$store.commit(types.MUTATE_USER, response)
                                      $this.$store.commit(types.MUTATE_MODIFIED, false)
                                      $this.$router.push('/register-success')
                                  }
                           })
                           .catch( error => {
                              if (error.response) {
                                    toast.error( error.response.message, "Error")
                                  } else if (error.request) {
                                    console.log(error.request)
                                    toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                                  } else {
                                    // Something happened in setting up the request that triggered an Error
                                    console.log('Error', error.message);
                                  }
                          })
                  }                   
             }
             else {
               toast.error( "Please complete all required fields", "Error")
             }

          })        
    },

    cancelEventHandler() {

      this.$router.push('/login')

    }

  },
  mounted() {
    // console.log("DECON_API: "+ process.env.DECON_API)
  },

  created() {    

    this.$store.dispatch(types.ACTION_FIND_AGENCIES)
    this.$store.commit(types.MUTATE_MODIFIED, false)
  }

}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

span.required {
  color:red; 
}

hr {
    margin-top: 0px;
    margin-bottom: 1.5rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.successful-server-response-wrapper {
    display: flex;
    justify-content: center;
    align-content: center;
}

.successful-server-response {
    text-align: center;
    max-width: 500px;
    font-size: 36px;
    background-color: #5cb85c;
    color: #f1f1f1;
    padding: 20px;
    border-radius: 3px;

}
</style>




// WEBPACK FOOTER //
// src/components/forms/Register.vue